// Module-level ref so that the HTTP service (non-React code) can read the
// current impersonation email set by the React ImpersonationContext.
export let currentImpersonation: string | null = null;

export function setCurrentImpersonation(email: string | null) {
  currentImpersonation = email;
}
